import ComponentLister from './lister.js';

export default class ComplexEstateLister extends ComponentLister {
  constructor(
      prefix = 'estate',
      sComponentMethod = 'EstateList::onGetJSONData',
      /** null - значит нет параметров, любое другое значение - параметр для стора */
      storeList = { active: null }
    ) {
    super(prefix, sComponentMethod, storeList);

    const listElement = this.findListElement();
    if (listElement) {
      const complexId = listElement.getAttribute('data-complex');
      if (complexId) {
        storeList = { ...storeList, complex: complexId };
      }
      const estateTypeId = listElement.getAttribute('data-estate_type');
      if (estateTypeId) {
        storeList = { ...storeList, estate_type: estateTypeId };
      }
      this.setStoreList(storeList);

      this.obItemBindCallback = function bindComplexItem (item) {
        var arProperty = {};
        for (let [key, obProperty] of Object.entries(item.property_value_array_extended)) {
          if (!obProperty || obProperty.length === 0) {
            return;
          }
          obProperty = obProperty[0]
          let value = obProperty.values.map(o => o['value']).join(', ');
          if (obProperty.code === 'finishing') {
            arProperty[`property-${obProperty.id}`] = value;
          } else {
            arProperty[`property-${obProperty.id}`] = `${obProperty.name}: ${value}`;
          }
        }
        return {
            img: item.hasOwnProperty('preview_image') && item['preview_image'] !== null ? item['preview_image'].path : null,
            title: item.dynamic_name,
            area: item.area,
            price: item.price,
            unitprice: item.unit_price,
            measure: item.measure,
            currency: item.currency,
            announcement: item.announcement_type.name || null,
            url: item.id,
            ...arProperty,
            ...item.locations_array
        };
      }
    }
  }
}
